module.exports = __webpack_public_path__ + "static/img/button-ios.e9ce31d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/button-ios.png
// module id = p6Si
// module chunks = 1